module.exports = __webpack_public_path__ + "static/media/top_blue.f5a873a1.png";